<!-- AI:
Status: 'in progress'
Type: Component
SubType: ObjectBaseModeComponent
Reason: Side view template of the lg.LogicMappingTable object component — compact cut of the four
        sections; the drawer host renders the navigation rail from the emitted items.
-->

@if (initialized && dto) {

    <div class="lg-mapping-table-side p-2">

        <!-- ============================= Overview ============================ -->
        @if (activeNavigationItem?.action === 'overview') {

            @if (isTableInactive()) {
                <div class="surface-card border-round border-left-3 border-orange-500 p-2 mb-2 flex align-items-start gap-2">
                    <p-tag value="Inaktiv" severity="warn"></p-tag>
                    <span class="text-sm">
                        Nicht mehr neu zuordenbar. Bestehende Zuordnungen laufen unverändert weiter.
                    </span>
                </div>
            }

            @if (isFallbackBehaviourMissing()) {
                <div class="surface-card border-round border-left-3 border-yellow-500 p-2 mb-2 flex align-items-start gap-2">
                    <i class="fa-solid fa-triangle-exclamation text-yellow-600 mt-1"></i>
                    <span class="text-sm">
                        Kein Fallback-Verhalten gesetzt — die Tabelle wirkt damit wie <strong>Fehler</strong>
                        und bricht bei jedem Nichttreffer ab.
                    </span>
                </div>
            }

            @if (widgetOverview) {
                <mvs-widget [widgetData]="widgetOverview"></mvs-widget>
            }

            <div class="text-color-secondary text-xs mt-2">
                Quellwerte werden zeichengenau verglichen. Das Feld „Ziel-Objekttyp“ ist gesperrt, weil es
                zur Laufzeit keine Wirkung hat. Zum Zurückziehen einer Tabelle die Einträge und Overrides deaktivieren
                statt die Tabelle zu löschen.
            </div>

        }

        <!-- ============================= Entries ============================= -->
        @if (activeNavigationItem?.action === 'entries') {
            @if (widgetEntries) {
                <mvs-widget [widgetData]="widgetEntries"></mvs-widget>
            }
        }

        <!-- =========================== Overrides ============================ -->
        @if (activeNavigationItem?.action === 'overrides') {
            @if (widgetOverrides) {
                <mvs-widget [widgetData]="widgetOverrides"></mvs-widget>
            }
        }

        <!-- =========================== Quick test =========================== -->
        @if (activeNavigationItem?.action === 'quickTest') {
            <!-- Binding contract: selector and inputs are agreed with the component specialist.
                 The component itself is declared in lg.module.ts. -->
            <mvs-lg-mapping-quick-test
                    [mappingTableId]="dto.id"
                    [mappingTableDto]="dto">
            </mvs-lg-mapping-quick-test>
        }

    </div>

}
